import leboSwitch from './index.vue'

leboSwitch.install = function (Vue) {
  Vue.component(leboSwitch.name, leboSwitch)
}

export default leboSwitch
